import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import {
  BOOKING_CONFIRMED,
  BOOKING_PENDING,
  BOOKING_ERROR,
  BOOKING_VARIANTS,
} from 'src/constants/voucher'
import IconGreenCheck from 'client/icons/GreenCheck'
import IconPendingCheck from 'client/icons/PendingCheck'

import {
  MessageHeaderBase,
  BookingStatus,
  BookingStatusText,
  BookingIcon,
  BookingIconPending,
  VoucherInformationRow,
  LeftSide,
  BookingUnconfirmedText,
} from './styles'

import messages from './messages'

const MessageHeader = ({ statuses, consumer = 'thanks' }) => {
  const pendingOrError = statuses?.some(
    status => status === BOOKING_PENDING || status === BOOKING_ERROR
  )

  return (
    <MessageHeaderBase className="noPrint">
      <VoucherInformationRow>
        {!pendingOrError && consumer === 'thanks' && (
          <LeftSide data-testid="confirmed-view">
            <BookingStatus>
              <BookingIcon>
                <IconGreenCheck />
              </BookingIcon>

              <BookingStatusText bookingStatus={BOOKING_CONFIRMED}>
                <FormattedMessage {...messages.yourPurchaseConfirmed} />
              </BookingStatusText>
            </BookingStatus>
          </LeftSide>
        )}

        {pendingOrError && (
          <LeftSide data-testid="pending-view">
            <BookingStatus>
              <BookingIconPending>
                <IconPendingCheck />
              </BookingIconPending>

              <BookingStatusText bookingStatus={BOOKING_PENDING}>
                <FormattedMessage {...messages.bookingPendingInformation} />
              </BookingStatusText>
            </BookingStatus>

            <BookingUnconfirmedText>
              <FormattedMessage {...messages.bookingPendingContactHotel} tagName="p" />
            </BookingUnconfirmedText>
          </LeftSide>
        )}
      </VoucherInformationRow>
    </MessageHeaderBase>
  )
}

MessageHeader.propTypes = {
  statuses: PropTypes.oneOf(BOOKING_VARIANTS),
  consumer: PropTypes.string,
}

export default MessageHeader
